<div class="row no-gutters mobile-view">
    <div
        class="view1"
        [ngClass]="{
            'slide-view-in': view === 1,
            'slide-view-out': view !== 1
        }"
    >
        <div class="item" (click)="setView(2, 'Subjects')">
            <span class="item-title">Subjects</span>
            <div class="arrow-right">
                <app-icon [type]="'Arrow-right'"></app-icon>
            </div>
        </div>

        <div class="item" (click)="setView(2, 'Grades')">
            <span class="item-title">Grades</span>
            <div class="arrow-right">
                <app-icon [type]="'Arrow-right'"></app-icon>
            </div>
        </div>

        <ng-container *ngIf="!userService.hasStudentExperience()">
            <div class="item">
                <a
                    [routerLink]="['/student']"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="{{ gtmPrefix + 'standards' }}"
                >
                    Student site
                    <em class="fas fa-external-link-alt ml-2"></em>
                </a>
            </div>
        </ng-container>
    </div>

    <div
        class="view2"
        [ngClass]="{
            'slide-view-in': view === 2,
            'slide-view-out': view !== 2
        }"
    >
        <div class="item back-btn" (click)="setView(1)">
            <div class="arrow-left">
                <app-icon [type]="'Arrow-left'"></app-icon>
            </div>
            <span class="item-title">Back</span>
        </div>
        <div class="item subject-title">
            {{ mobileSubjectTitle }}
        </div>
        <div *ngIf="mobileSubjectTitle === 'Subjects'">
            <div
                class="item"
                *ngFor="let discipline of disciplines"
                (click)="setView(3, discipline.title, discipline)"
            >
                <span class="item-title" [ngClass]="getColorClass(discipline)">{{
                    discipline.title
                }}</span>
                <div class="arrow-right">
                    <app-icon [type]="'Arrow-right'"></app-icon>
                </div>
            </div>
        </div>

        <div class="grades" *ngIf="mobileSubjectTitle === 'Grades'">
            <div class="item">
                <app-link
                    class="{{ gtmPrefix + 'grade-band' }}"
                    [attr.data-gtmlabel]="'PreK'"
                    appRouterLink="/grades/PreK-K"
                    >PreK-K</app-link
                >
            </div>

            <div class="item">
                <app-link
                    appRouterLink="/grades/K-2"
                    class="{{ gtmPrefix + 'grade-band' }}"
                    [attr.data-gtmlabel]="'Early Elementary'"
                >
                    Early Elementary
                </app-link>
            </div>
            <div class="item">
                <app-link
                    appRouterLink="/grades/3-5"
                    class="{{ gtmPrefix + 'grade-band' }}"
                    [attr.data-gtmlabel]="'Upper Elementary'"
                >
                    Upper Elementary
                </app-link>
            </div>

            <div class="item">
                <app-link
                    appRouterLink="/grades/6-8"
                    class="{{ gtmPrefix + 'grade-band' }}"
                    [attr.data-gtmlabel]="'Middle School'"
                >
                    Middle School
                </app-link>
            </div>
            <div class="item">
                <app-link
                    appRouterLink="/grades/9-12"
                    class="{{ gtmPrefix + 'grade-band' }}"
                    [attr.data-gtmlabel]="'High School'"
                >
                    High School
                </app-link>
            </div>
        </div>
    </div>

    <div
        class="view3"
        [ngClass]="{
            'slide-view-in': view === 3,
            'slide-view-out': view !== 3
        }"
    >
        <div class="item back-btn" (click)="setView(2, 'Subjects')">
            <div class="arrow-left">
                <app-icon [type]="'Arrow-left'"></app-icon>
            </div>
            <span class="item-title">Back</span>
        </div>

        <div *ngIf="view3Discipline" class="item subject-title">
            <a
                [routerLink]="view3Discipline.getBrowseURL()"
                [ngClass]="getColorClass(view3Discipline)"
                >{{ mobileSubjectTitle }}</a
            >
        </div>
        <div *ngIf="view3Discipline">
            <div class="item" *ngFor="let child of getAvailableSubjects(view3Discipline)">
                <app-link
                    [appRouterLink]="child.getBrowseURL()"
                    [ngClass]="getColorClass(view3Discipline)"
                    class="{{
                        getColorClassString(view3Discipline) + ' ' + gtmPrefix + 'child-title'
                    }}"
                    [attr.data-gtmlabel]="child.title"
                >
                    {{ child.title }}</app-link
                >
            </div>
        </div>
    </div>

    <div class="fake-view" #fakeView></div>
</div>
